import React, { useCallback, useState } from "react";
import { useTable } from "react-table";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import { Container, Card } from "reactstrap";
import ConfirmationDialog from "../ConfirmDialog";

const MergingTable = ({ tableData, tableColumns, selectedCells, setSelectedCells,debouncedValue,debouncedSearchTerm,setApiData,apiData,Tablekey,isMergeContact_id,selectedCategory,setIsMergingWarningPopup,capitalizedModuleName,sortState ,setSortState,handleSort}) => {

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns:  tableColumns ,  data:  tableData});
   const [deleteData, setDeleteData] = useState(null);
 
  const normalizeColumn = (col) => col.toLowerCase().replace(/[_\s]/g, "");
  
  // const toggleCellSelectionWithMerge = useCallback(
  //   (rowId, columnId, type, value, row, isRowSelection = false) => {
  //     if (!row || !type || !columnId) return; // Ensure required data exists
  
  //     setSelectedCells((prevSelectedCells) => {
  //       const selectedData = prevSelectedCells.selectedData || [];
  //       const isMerge = prevSelectedCells.isMerge || [];
  
  //       const normalizeColumn = (col) => (col ? col.toLowerCase().replace(/[_\s]/g, "") : "");
  //       const normalizedColumnId = normalizeColumn(columnId);
  
  //       let updatedSelectedData = [...selectedData];
  //       let updatedIsMerge = [...isMerge];
  
  //       if (isRowSelection) {
  //         // ✅ Handle "Select is Merge" checkbox toggle for the row
  //         let mergeIndex = updatedIsMerge.findIndex(
  //           (item) =>
  //             item.type === type &&
  //             ((item.contact_id && item.contact_id === row.contact_id) ||
  //               (item.company_id && item.company_id === row.company_id))
  //         );
  
  //         if (mergeIndex !== -1) {
  //           // ❌ Unmerge: Remove row from isMerge
  //           updatedIsMerge.splice(mergeIndex, 1);
  //           // ❌ Remove all selected cells from this row in the same table
  //           updatedSelectedData = updatedSelectedData.filter(
  //             (cell) => !(cell.rowId === rowId && cell.type === type)
  //           );
  //         } else {
  //           // ✅ Merge: Add row to isMerge
  //           updatedIsMerge.push({ ...row, type });
  //         }
  //       } else {
  //         // ✅ Handle individual cell selection
  //         let existingSelectionIndex = updatedSelectedData.findIndex(
  //           (cell) =>
  //             cell.rowId === rowId &&
  //             cell.type === type &&
  //             normalizeColumn(cell.columnId) === normalizedColumnId &&
  //             cell.value === value
  //         );
  
  //         if (existingSelectionIndex !== -1) {
  //           // ❌ Unselect cell
  //           updatedSelectedData.splice(existingSelectionIndex, 1);
  //         } else {
  //           // ❌ Remove previous selection in the same column for this table
  //           updatedSelectedData = updatedSelectedData.filter(
  //             (cell) =>
  //               !(
  //                 cell.type === type &&
  //                 normalizeColumn(cell.columnId) === normalizedColumnId
  //               )
  //           );
  
  //           // ✅ Add new selection
  //           updatedSelectedData.push({ rowId, columnId, type, value, contact_id: row.contact_id });
  //         }
  
  //         // 🔥 Ensure "Select is Merge" for this row is updated correctly
  //         let hasSelectedCells = updatedSelectedData.some((cell) => cell.rowId === rowId && cell.type === type);
  
  //         if (hasSelectedCells) {
  //           let alreadyMerged = updatedIsMerge.some(
  //             (item) =>
  //               item.type === type &&
  //               ((item.contact_id && item.contact_id === row.contact_id) ||
  //                 (item.company_id && item.company_id === row.company_id))
  //           );
  
  //           if (!alreadyMerged) {
  //             updatedIsMerge.push({ ...row, type });
  //           }
  //         } else {
  //           // ❌ If no cells remain selected in this row, unmerge it
  //           updatedIsMerge = updatedIsMerge.filter(
  //             (item) =>
  //               !(item.type === type &&
  //                 ((item.contact_id && item.contact_id === row.contact_id) ||
  //                   (item.company_id && item.company_id === row.company_id)))
  //           );
  //         }
  //       }
  
  //       return {
  //         ...prevSelectedCells,
  //         selectedData: updatedSelectedData,
  //         isMerge: updatedIsMerge,
  //       };
  //     });
  //   },
  //   []
  // );
 
  // const toggleCellSelectionWithMerge = useCallback( //it will call when each cell is been checked and handle all isMerge and selectedData stored
  //   (rowId, columnId, type, value, row, isRowSelection = false) => {
  //     if (!row || !type || !columnId) return; // Ensure required data exists
  
  //     setSelectedCells((prevSelectedCells) => {
  //       const selectedData = prevSelectedCells.selectedData || [];
  //       const isMerge = prevSelectedCells.isMerge || [];
  
  //       const normalizeColumn = (col) => (col ? col.toLowerCase().replace(/[_\s]/g, "") : "");
  //       const normalizedColumnId = normalizeColumn(columnId);
  
  //       let updatedSelectedData = [...selectedData];
  //       let updatedIsMerge = [...isMerge];
  
  //       if (isRowSelection) {
  //         // ✅ Handle "Select is Merge" checkbox toggle for the row
  //         let mergeIndex = updatedIsMerge.findIndex(
  //           (item) =>
  //             item.type === type &&
  //             ((item.contact_id && item.contact_id === row.contact_id) ||
  //               (item.company_id && item.company_id === row.company_id))
  //         );
  
  //         if (mergeIndex !== -1) {
  //           // ❌ Unmerge: Remove row from isMerge
  //           updatedIsMerge.splice(mergeIndex, 1);
  //           // ❌ Remove all selected cells from this row in the same table
  //           updatedSelectedData = updatedSelectedData.filter(
  //             (cell) => !(cell.rowId === rowId && cell.type === type)
  //           );
  //         } else {
  //           // ✅ Merge: Add row to isMerge
  //           updatedIsMerge.push({ ...row, type });
  //         }
  //       } else {
  //         // ✅ Handle individual cell selection
  //         let existingSelectionIndex = updatedSelectedData.findIndex(
  //           (cell) =>
  //             cell.rowId === rowId &&
  //             cell.type === type &&
  //             normalizeColumn(cell.columnId) === normalizedColumnId &&
  //             cell.value === value
  //         );
  
  //         if (existingSelectionIndex !== -1) {
  //           // ❌ Unselect cell
  //           updatedSelectedData.splice(existingSelectionIndex, 1);
  //         } else {
  //           // ❌ Remove previous selection in the same column for this table
  //           updatedSelectedData = updatedSelectedData.filter(
  //             (cell) =>
  //               !(
  //                 cell.type === type &&
  //                 normalizeColumn(cell.columnId) === normalizedColumnId
  //               )
  //           );
  
  //           // ✅ Add new selection
  //           updatedSelectedData.push({
  //             rowId,
  //             columnId,
  //             type,
  //             value,
  //             contact_id: row.contact_id ? row.contact_id : null,
  //             company_id: row.company_id ? row.company_id : null,
  //           });
  //         }
  
  //         // 🔥 Ensure "Select is Merge" for this row is updated correctly
  //         let hasSelectedCells = updatedSelectedData.some(
  //           (cell) => cell.rowId === rowId && cell.type === type
  //         );
  
  //         if (hasSelectedCells) {
  //           let alreadyMerged = updatedIsMerge.some(
  //             (item) =>
  //               item.type === type &&
  //               ((item.contact_id && item.contact_id === row.contact_id) ||
  //                 (item.company_id && item.company_id === row.company_id))
  //           );
  
  //           if (!alreadyMerged) {
  //             updatedIsMerge.push({ ...row, type });
  //           }
  //         }

  //         //✅ Fix: Remove any row from isMerge if no cells are selected for it
  //         updatedIsMerge = updatedIsMerge.filter((item) =>
  //           updatedSelectedData.some(
  //             (cell) =>
  //               (cell.contact_id === item.contact_id &&
  //                 cell.type === item.type) ||
  //               (cell.company_id === item.company_id && cell.type === item.type)
  //           )
  //         );
  //       }
  
  
  //       return {
  //         ...prevSelectedCells,
  //         selectedData: updatedSelectedData,
  //         isMerge: updatedIsMerge,
  //       };
  //     });
  //   },
  //   []
  // );

  const filterUnmatchedContacts = (uniqueId, type) => { //function call for soft delete from ui 
    if (!apiData || typeof apiData !== "object") return;

    // Explicit mapping for "Team" to "Team-Members"
    const typeKey = type === "Team" ? "Team-Members" : type;

    if (!apiData[typeKey]) return apiData; // Return original data if key not found

    const updatedData = { ...apiData };

    if (Array.isArray(updatedData[typeKey])) {
        // Remove only the matching contact_id from the correct key
        updatedData[typeKey] = updatedData[typeKey].filter(item => !(item.contact_id === uniqueId || item.company_id === uniqueId));
    }
    return updatedData;
};

const handleDelete = (row, type) => { //handleing delete function
  const moduleRowId = row.contact_id ? row.contact_id : row.company_id
    const filteredData = filterUnmatchedContacts(moduleRowId, type);
    const upDatedType = 
    type === "Team-Members" ? "Team" 
  : type === "Investors" ? "Investor" 
  : type === "Firm" ? "firms" 
  : type;

    setApiData(filteredData); // Update state with the new filtered data
    setSelectedCells((prevSelectedCells) => {
      const selectedData = prevSelectedCells && prevSelectedCells.selectedData ? prevSelectedCells.selectedData : [];
      const isMerge = prevSelectedCells && prevSelectedCells.isMerge ? prevSelectedCells.isMerge : [];
      const isDeleted = prevSelectedCells && prevSelectedCells.isDeleted ? prevSelectedCells.isDeleted : [];
  
      return {
        ...prevSelectedCells,
        selectedData,
        isMerge,
        isDeleted: [
          ...isDeleted,
          {
            ...row,
            ...(capitalizedModuleName === "Contacts" && { removed_type: upDatedType })
          }
        ]
      };
        });
};

const toggleCellSelectionWithMerge = (
  rowId,
  columnId,
  type,
  value,
  row,
  isRowSelection = false,
  isColumn_Contact_company_id = false,
  mergeList = []
) => {
  if (!row || !type || isColumn_Contact_company_id) return;

  setSelectedCells(function (prevSelectedCells) {
    const selectedData = prevSelectedCells.selectedData || [];
    const isMerge = prevSelectedCells.isMerge || [];

    function normalizeColumn(col) {
      return col ? col.toLowerCase().replace(/[_\s]/g, "") : "";
    }

    function normalizeType(t) {
      return t ? t.toLowerCase().replace(/s$/, "") : "";
    }

    const normalizedColumnId = normalizeColumn(columnId);

    const upDatedType =
      type === "Team-Members"
        ? "Team"
        : type === "Investors"
        ? "Investor"
        : type === "Firm"
        ? "Company"
        : type;

    let updatedSelectedData = selectedData.slice();
    let updatedIsMerge = isMerge.slice();

    if (isRowSelection) {
      const hasExisting = updatedIsMerge.some(function (item) {
        return (
          (item.contact_id && row.contact_id && item.contact_id === row.contact_id) ||
          (item.company_id && row.company_id && item.company_id === row.company_id)
        );
      });

      if (hasExisting) {
        updatedIsMerge = updatedIsMerge.filter(function (item) {
          return !(
            (item.contact_id && row.contact_id && item.contact_id === row.contact_id) ||
            (item.company_id && row.company_id && item.company_id === row.company_id)
          );
        });

        updatedSelectedData = updatedSelectedData.filter(function (cell) {
          return !(
            (row.contact_id && cell.contact_id === row.contact_id) ||
            (row.company_id && cell.company_id === row.company_id)
          );
        });
      } else {
        let allRecords = [];
        for (let key in mergeList) {
          if (Array.isArray(mergeList[key])) {
            allRecords = allRecords.concat(mergeList[key]);
          }
        }

        let matchingRows = [];

        if (row.contact_id != null) {
          matchingRows = allRecords.filter(function (item) {
            return item.contact_id === row.contact_id;
          });
        } else if (row.company_id != null) {
          matchingRows = allRecords.filter(function (item) {
            return item.company_id === row.company_id;
          });
        }

        for (let i = 0; i < matchingRows.length; i++) {
          const match = matchingRows[i];
          const contactTypes = Array.isArray(match.contact_type) ? match.contact_type : [];

          if (contactTypes.length > 0) {
            for (let j = 0; j < contactTypes.length; j++) {
              const ct = contactTypes[j];
              const normalizedType = ct === "Firm" ? "Company" : ct;
              if (normalizedType === "Team") continue;

              const contactObj = Object.assign({}, match, { type: normalizedType });

              if (capitalizedModuleName === "Contacts") {
                contactObj.removed_type = normalizedType;
              }

              updatedIsMerge.push(contactObj);
            }
          } else {
            if (type === "Team") continue;
            const contactObj = Object.assign({}, match, { type: upDatedType });
            if (capitalizedModuleName === "Contacts") {
              contactObj.removed_type = upDatedType;
            }
            updatedIsMerge.push(contactObj);
          }
        }

        updatedIsMerge = updatedIsMerge.filter(function (item, index, self) {
          return (
            index ===
            self.findIndex(function (t) {
              return (
                t.contact_id === item.contact_id &&
                t.arcimedes_row_id === item.arcimedes_row_id &&
                normalizeType(t.type) === normalizeType(item.type)
              );
            })
          );
        });
      }
    } else {
      const existingIndex = updatedSelectedData.findIndex(function (cell) {
        return (
          cell.rowId === rowId &&
          normalizeColumn(cell.columnId) === normalizedColumnId &&
          cell.value === value &&
          cell.type === type
        );
      });

      if (existingIndex !== -1) {
        updatedSelectedData.splice(existingIndex, 1);
      } else {
        updatedSelectedData = updatedSelectedData.filter(function (cell) {
          return normalizeColumn(cell.columnId) !== normalizedColumnId;
        });

        const newCell = {
          rowId: rowId,
          columnId: columnId,
          type: type,
          value: value,
          contact_id: typeof row.contact_id !== "undefined" ? row.contact_id : null,
          company_id: typeof row.company_id !== "undefined" ? row.company_id : null,
          arcimedes_row_id: typeof row.arcimedes_row_id !== "undefined" ? row.arcimedes_row_id : null,
        };

        if (typeof row.parent_firm !== "undefined") {
          newCell.parent_firm = row.parent_firm;
        }
        if (typeof row.firm_id !== "undefined") {
          newCell.firm_id = row.firm_id;
        }

        updatedSelectedData.push(newCell);
      }

      let hasSelectedCells = false;

      if (row.contact_id != null) {
        hasSelectedCells = updatedSelectedData.some(function (cell) {
          return cell.contact_id === row.contact_id;
        });
      } else if (row.company_id != null) {
        hasSelectedCells = updatedSelectedData.some(function (cell) {
          return cell.company_id === row.company_id;
        });
      }

      if (hasSelectedCells) {
        let allRecords = [];
        for (let key in mergeList) {
          if (Array.isArray(mergeList[key])) {
            allRecords = allRecords.concat(mergeList[key]);
          }
        }

        let matchingRows = [];

        if (row.contact_id != null) {
          matchingRows = allRecords.filter(function (item) {
            return item.contact_id === row.contact_id;
          });
        } else if (row.company_id != null) {
          matchingRows = allRecords.filter(function (item) {
            return item.company_id === row.company_id;
          });
        }

        for (let i = 0; i < matchingRows.length; i++) {
          const match = matchingRows[i];
          const contactTypes = Array.isArray(match.contact_type) ? match.contact_type : [];

          if (contactTypes.length > 0) {
            for (let j = 0; j < contactTypes.length; j++) {
              const ct = contactTypes[j];
              const normalizedType = ct === "Firm" ? "Company" : ct;
              if (normalizedType === "Team") continue;

              const contactObj = Object.assign({}, match, { type: normalizedType });

              if (capitalizedModuleName === "Contacts") {
                contactObj.removed_type = normalizedType;
              }

              updatedIsMerge.push(contactObj);
            }
          } else {
            if (type === "Team") continue;
            const contactObj = Object.assign({}, match, { type: upDatedType });
            if (capitalizedModuleName === "Contacts") {
              contactObj.removed_type = upDatedType;
            }
            updatedIsMerge.push(contactObj);
          }
        }

        updatedIsMerge = updatedIsMerge.filter(function (item, index, self) {
          return (
            index ===
            self.findIndex(function (t) {
              return (
                t.contact_id === item.contact_id &&
                t.arcimedes_row_id === item.arcimedes_row_id &&
                normalizeType(t.type) === normalizeType(item.type)
              );
            })
          );
        });
      } else {
        updatedIsMerge = updatedIsMerge.filter(function (item) {
          return !(
            (row.contact_id && item.contact_id && item.contact_id === row.contact_id) ||
            (row.company_id && item.company_id && item.company_id === row.company_id)
          );
        });
      }
    }

    return {
      selectedData: updatedSelectedData,
      isMerge: updatedIsMerge,
    };
  });
};


const getArrowColor = (columnId, direction, Tablekey) => {
   const type = Tablekey === "Team-Members" ? "Teams" : Tablekey || null; //new code for type
  const sort = sortState.find(
    (s) => s.field === columnId && s.order === direction && s.type === type
  );
  return sort ? "#fff" : "rgba(0, 0, 0, 0.4)";
};

  return (
    <div>
      <Container
        style={{
          marginTop: "20px",
          marginLeft: "4px",
          backgroundColor: "white",
          maxWidth: "1928px",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Card style={{ marginTop: "16px", marginLeft: "16px" }}>
          <h5 style={{ fontSize: "1.5rem", marginLeft: "6px" }}>
           {
    (() => {
      if (Tablekey.toLowerCase() === "firm") {
        return "Company";
      }

      let label = Tablekey.replace(/[_-]/g, " ").trim();

      // Add "s" if not already plural
      if (!label.toLowerCase().endsWith("s")) {
        label += "s";
      }

      // Convert to Title Case (e.g. "team members" → "Team Members")
      return label.replace(/\b\w/g, char => char.toUpperCase());
    })()
  }
          </h5>
          <div
            style={{
              width: "100%",
              overflowX: "auto", // ✅ Enables horizontal scroll
            }}
          >
            <div
              style={{
                maxHeight: "400px", // Enables vertical scroll
                overflowY: "auto", // Required for scrollable body
                position: "relative", // Required for sticky headers
              }}
            >
              <table
                {...getTableProps()}
                style={{
                  width: "110%",
                  minWidth: "900px",
                  borderCollapse: "separate",
                  borderSpacing: "0",
                  borderRadius: "12px",
                  // overflow: "hidden",.
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr
                      {...headerGroup.getHeaderGroupProps()}
                      key={headerGroup.id}
                    >
                      {headerGroup.headers.map((column, index, arr) => {
                        const isSortable =
                          column.id === "first_name" ||
                          column.id === "last_name" ||
                         ( column.id.toLowerCase() === "name" && column.Header.toLowerCase() === 'company');

                        return (
                          <th
                            {...column.getHeaderProps()}
                            key={column.id}
                            style={{
                              position: "sticky", // ✅ Make header sticky
                              top: 0, // ✅ Stick to top
                              zIndex: 2, // ✅ Stay above tbody content
                              width: "150px",
                              border: "1px solid  rgb(0,0,0,0.4)",
                              padding: "0px",
                              background: "#90C54B",
                              color: "white",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              borderTopLeftRadius: index === 0 ? "12px" : "0",
                              borderTopRightRadius:
                                index === arr.length - 1 ? "12px" : "0",
                              cursor: isSortable ? "pointer" : "default",
                            }}
                            onClick={() =>
                              isSortable && handleSort(column.id, Tablekey)
                            }
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                lineHeight: "1",
                                padding: "2px 4px",
                                gap: "2px",
                              }}
                            >
                              {isSortable && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: getArrowColor(
                                      column.id,
                                      "asc",
                                      Tablekey
                                    ),
                                    lineHeight: "1",
                                  }}
                                >
                                  ▲
                                </span>
                              )}

                              <div>{column.render("Header")}</div>

                              {isSortable && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: getArrowColor(
                                      column.id,
                                      "desc",
                                      Tablekey
                                    ),
                                    lineHeight: "1",
                                  }}
                                >
                                  ▼
                                </span>
                              )}
                            </div>
                          </th>
                        );
                      })}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {rows.length === 0 ? (
                    <tr>
                      <td
                        colSpan={tableColumns.length}
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#555",
                          padding: "12px",
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          margin: "8px 0", // Keeps the nice top and bottom margin
                          width: "100%", // Ensures it takes full table width
                          display: "table-cell", // Makes sure it behaves like a normal table cell
                        }}
                      >
                        No duplicate records found
                      </td>
                    </tr>
                  ) : (
                    rows.map((row, rowIndex, rowArray) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()} key={row.id}>
                          {row.cells.map((cell, cellIndex, cellArray) => {
                            const columnAccessor = cell.column.id.toLowerCase();
                            const columnId = cell.column.Header.toLowerCase();
                            const rowId = row.id;
                            // let cellValue =
                            //   typeof cell.value === "string"
                            //     ? cell.value.trim()
                            //     : React.isValidElement(cell.value)
                            //     ? React.Children.toArray(cell.value.props.children)
                            //         .join("")
                            //         .trim()
                            //     : "";
                            let cellValue =
                              typeof cell.value === "string"
                                ? cell.value.trim()
                                : React.isValidElement(cell.value)
                                ? React.Children.toArray(
                                    cell.value.props.children
                                  )
                                    .join("")
                                    .trim()
                                : typeof cell.value === "number"
                                ? cell.value.toString()
                                : "";
                            const isValidValue = cellValue.length > 0;
                            // let type = "";    //previous old code for type
                            // const { contact_type, company_type } = row.original;
                            // const hasContactType =
                            //   Array.isArray(contact_type) && contact_type.length > 0;
                            // const hasCompanyType =
                            //   Array.isArray(company_type) && company_type.length > 0;
                            // if (hasContactType || hasCompanyType) {
                            //   type = hasContactType ? contact_type[0] : company_type[0];
                            // }
                            const type =
                              Tablekey === "Teams"
                                ? "Team-Members"
                                : Tablekey || null; //new code for type
                            const isChecked = (
                              selectedCells.selectedData || []
                            ).some(
                              (selectedCell) =>
                                selectedCell.rowId === rowId &&
                                normalizeColumn(selectedCell.columnId) ===
                                  normalizeColumn(columnId) &&
                                selectedCell.value === cellValue &&
                                selectedCell.type === type
                            );
                            // const isMerged = (selectedCells.isMerge || []).some(
                            //   (item) =>
                            //     (item.contact_id && item.contact_id === row.original.contact_id) ||
                            //     (item.company_id && item.company_id === row.original.company_id)
                            // );
                            const isMerged = (selectedCells.isMerge || []).some(
                              (item) =>
                                //  item.type === type && // Ensure merging is only within the same type
                                ((item.contact_id &&
                                  item.contact_id ===
                                    row.original.contact_id) ||
                                  (item.company_id &&
                                    item.company_id ===
                                      row.original.company_id))
                            );
                          
        const isLesserContactId = (() => {
          const mergeList = selectedCells.isMerge || [];
          if (mergeList.length > 1) {
            // Filter only those with valid contact_id or company_id and match the current row
            const contactIds = mergeList
              .filter(
                (item) =>
                  (item.contact_id != null || item.company_id != null) &&
                  (item.contact_id === row.original.contact_id ||
                    item.company_id === row.original.company_id)
              )
              .map((item) => Number(item.contact_id || item.company_id)); // <-- Use whichever is present

            if (contactIds.length === 0) return false;

            const minContactId = Math.min(...contactIds);
            return (
              Number(row.original.contact_id || row.original.company_id) ===
              minContactId
            );
          } else if (mergeList.length === 1) {
            const item = mergeList[0];
            return (
              (item.contact_id != null || item.company_id != null) &&
              String(item.contact_id || item.company_id) ===
                String(row.original.contact_id || row.original.company_id)
            );
          }

  return false;
})();
                            return (
                              <td
                                {...cell.getCellProps()}
                                key={columnId}
                                style={{
                                  width: "150px",
                                  border: "1px solid  rgb(0,0,0,0.4)",
                                  padding: "8px",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  background: isChecked ? "azure" : "white",
                                  borderBottomLeftRadius:
                                    rowIndex === rowArray.length - 1 &&
                                    cellIndex === 0
                                      ? "12px"
                                      : "0",
                                  borderBottomRightRadius:
                                    rowIndex === rowArray.length - 1 &&
                                    cellIndex === cellArray.length - 1
                                      ? "12px"
                                      : "0",
                                }}
                              >
                                {columnAccessor === "ismerge" ? (
                                  <input
                                    type="checkbox"
                                    checked={isMerged}
                                    style={{ accentColor: "green",cursor:"pointer" }}
                                    onChange={() => {
                                      toggleCellSelectionWithMerge(
                                        rowId,
                                        null,
                                        type,
                                        null,
                                        row.original,
                                        true,
                                        false,
                                        apiData
                                      );
                                    }}
                                  />
                                ) : columnAccessor === "contact_id" || columnAccessor === "company_id" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span style={{ flex: 1 }}>
                                      {cell.render("Cell")}
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={isLesserContactId}
                                      style={{ accentColor: "green" }}
                                      onChange={() => {
                                        toggleCellSelectionWithMerge(
                                          rowId,
                                          null,
                                          type,
                                          null,
                                          row.original,
                                          true,
                                          true,
                                          apiData
                                        );
                                      }}
                                    />
                                  </div>
                                ) : columnAccessor === "action" ? (
                                  <IconButton
                                    onClick={() => {
                                      const idToCheck =
                                        capitalizedModuleName === "Contacts"
                                          ? row.original.contact_id
                                          : row.original.company_id;

                                      const isDeletedRow = (
                                        selectedCells.selectedData || []
                                      ).some(
                                        (selectedCell) =>
                                          selectedCell.type === type &&
                                          isMergeContact_id.includes(idToCheck)
                                      );
                                      if (isDeletedRow) {
                                        setIsMergingWarningPopup(true);
                                      } else {
                                        setDeleteData({
                                          row: row.original,
                                          type,
                                        });
                                      }
                                    }}
                                  >
                                    <DeleteIcon style={{ color: "red" }} />
                                  </IconButton>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span style={{ flex: 1 }}>
                                      {cell.render("Cell")}
                                    </span>
                                    {isValidValue && (
                                      <input
                                        type="checkbox"
                                        style={{
                                          marginLeft: "10px",
                                          cursor: "pointer",
                                          accentColor: "green",
                                        }}
                                        checked={isChecked}
                                        onChange={() => {
                                       toggleCellSelectionWithMerge(
                                         rowId,
                                         columnId,
                                         type,
                                         cellValue,
                                         row.original,
                                         false, // isRowSelection
                                         false, // isColumn_Contact_company_id
                                         apiData // ✅ Pass the full merged data list here
                                       );
                                        }}
                                      />
                                    )}
                                  </div>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
              {deleteData && (
                <ConfirmationDialog
                  open={true}
                  onClose={(result) => {
                    if (result === "ok" && deleteData) {
                      handleDelete(deleteData.row, deleteData.type);
                    }
                    setDeleteData(null); // Reset state regardless of choice
                  }}
                  isMergeScreen={true}
                />
              )}
            </div>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default React.memo(MergingTable);



